module.exports = __webpack_public_path__ + "img/comparisons-table.fd8ca8bd.svg";